import { gql } from '@apollo/client'

// Minimal query used by the nav dropdown — only the fields guaranteed to exist
export const GET_CLIENTS_NAV = gql`
  query GetClientsNav {
    clients {
      id
      brandName
      agentName
      websiteUrl
    }
  }
`

export const GET_CLIENTS = gql`
  query GetClients {
    clients {
      id brandName agentName industry websiteUrl modelProvider modelId
      autoRun autoPublish selectedContentTypes disabledAt createdAt updatedAt
      runs(limit: 1) { id status startedAt }
      analytics { totalLeads leadsThisMonth totalClicks }
    }
  }
`

export const GET_CLIENT = gql`
  query GetClient($id: ID!) {
    client(id: $id) {
      id ownerUid brandName brandLocation brandSpecialization industry
      websiteUrl modelProvider modelId agentName autoRun autoPublish
      budgetLimitDailyUsd selectedContentTypes compliancePrompt
      disabledAt createdAt updatedAt
      platforms { platform connected connectedAt }
      knowledgeFiles { filename size type chunks uploadedAt }
      runs(limit: 10) { id status startedAt completedAt resultsCount estimatedCostUsd }
      publishQueue { id contentType status createdAt }
      analytics { totalLeads leadsThisMonth totalClicks }
      webhooks { url }
      marketingProfile {
        phone ctaUrl campaignGoal gbpReviewCount gbpRating
        facebookUrl linkedinUrl twitterUrl
      }
      capabilities {
        businessDescription productCategories servicesOffered
        deliveryTimeline serviceArea acceptedInsurance ehrIntegrations
      }
      contentInclusion {
        includeAddress includePhone includeEmail
        includeWebsite includePricing includeStaffNames
      }
      schedulingConfig {
        autoGenerate {
          enabled contentTypes cadence timeUtc daysOfWeek cronExpr timezone
        }
        notifyOnQueue lastAutoRunAt nextAutoRunAt
      }
    }
  }
`

export const GET_CLIENT_DASHBOARD = gql`
  query GetClientDashboard($id: ID!) {
    clientDashboard(id: $id) {
      client { id brandName agentName }
      recentRuns { id status startedAt completedAt resultsCount }
      publishQueueCount
      pendingCount
    }
  }
`

export const CREATE_CLIENT = gql`
  mutation CreateClient($input: CreateClientInput!) {
    createClient(input: $input) {
      id brandName agentName industry createdAt
    }
  }
`

export const UPDATE_CLIENT = gql`
  mutation UpdateClient($id: ID!, $input: UpdateClientInput!) {
    updateClient(id: $id, input: $input) {
      id brandName brandLocation brandSpecialization industry websiteUrl
      modelProvider modelId agentName autoRun autoPublish budgetLimitDailyUsd
      selectedContentTypes compliancePrompt updatedAt
      marketingProfile {
        phone ctaUrl campaignGoal gbpReviewCount gbpRating
        facebookUrl linkedinUrl twitterUrl
      }
      capabilities {
        businessDescription productCategories servicesOffered
        deliveryTimeline serviceArea acceptedInsurance ehrIntegrations
      }
      contentInclusion {
        includeAddress includePhone includeEmail
        includeWebsite includePricing includeStaffNames
      }
      schedulingConfig {
        autoGenerate {
          enabled contentTypes cadence timeUtc daysOfWeek cronExpr timezone
        }
        notifyOnQueue lastAutoRunAt nextAutoRunAt
      }
    }
  }
`

export const DELETE_CLIENT = gql`
  mutation DeleteClient($id: ID!) {
    deleteClient(id: $id)
  }
`

export const SCRAPE_WEBSITE = gql`
  mutation ScrapeWebsite($clientId: ID!, $url: String!) {
    scrapeWebsite(clientId: $clientId, url: $url)
  }
`

export const EXTRACT_WEBSITE_FIELDS = gql`
  mutation ExtractWebsiteFields($clientId: ID!, $url: String!) {
    extractWebsiteFields(clientId: $clientId, url: $url) {
      brandName brandLocation brandSpecialization industry phone
      businessDescription servicesOffered productCategories serviceArea
      facebookUrl linkedinUrl twitterUrl ctaUrl
    }
  }
`

export const RECOMMEND_CAMPAIGN_SETTINGS = gql`
  mutation RecommendCampaignSettings($clientId: ID!) {
    recommendCampaignSettings(clientId: $clientId) {
      campaignGoal
      selectedContentTypes
      scheduleCadence
      scheduleTimeUtc
      scheduleDaysOfWeek
    }
  }
`

export const TRIGGER_AUTO_RUN = gql`
  mutation TriggerAutoRun($clientId: ID!) {
    triggerAutoRun(clientId: $clientId)
  }
`
